import Requests from "@/services/Requests";

export default {
  data() {
    return {
      batteryItem: null,
      allFeatures: [],
      batteryIsLoaded: false,
    };
  },
  computed: {
    getBatteryLoadingById() {
      return this.$store.getters["getBatteryLoadingById"];
    },
    getBattery() {
      return this.$store.getters["getBatteryById"](this.batteryId);
    },
    batteryFeatures() {
      return this.allFeatures.filter((item) => !item.isResult);
    },
    batteryResultFeatures() {
      return this.allFeatures.filter((item) => item.isResult);
    },
  },
  methods: {
    async getFeatures(battery) {
      this.batteryIsLoaded = false;
      const response = await Requests.BatteryFeatures.GetAll({
        query: { batteryType: battery.type },
      });
      if (response.message === "OK") {
        this.allFeatures = response.data.map((item) => ({
          ...item,
          options: item.options.map((option) => {
            if (battery.id) {
              const section = battery[item.bodyKey] || {};
              const value =
                section[option.bodyValue] || section[option.bodyKey] || null;
              return {
                ...option,
                value: value,
              };
            } else {
              return {
                ...option,
                value: null,
              };
            }
          }),
          show: true,
        }));
      }

      this.batteryIsLoaded = true;
    },
    setBatteryItem() {
      if (this.battery) {
        this.batteryItem = { ...this.battery };
        this.getFeatures(this.battery);
        this.$emit("battery-loaded", this.battery);
      } else {
        this.GET_BATTERY(this.force === false ? false : true || true);
      }
    },
    async GET_BATTERY(force = false) {
      console.log("force", force);

      const response = await this.$store.dispatch("getBatteryById", {
        id: this.batteryId,
        force,
      });
      if (response.message === "OK") {
        this.batteryItem = { ...response.data };
        this.getFeatures(response.data);
        document.title = this.batteryItem.name + " " + document.title;
        this.$emit("battery-loaded", response.data);
      } else {
        this.batteryItem = null;
        this.batteryIsLoaded = true;
      }
    },
  },
  mounted() {
    this.setBatteryItem();
  },
};
